import { render, staticRenderFns } from "./ListRoom.vue?vue&type=template&id=6bd96c37"
import script from "./ListRoom.vue?vue&type=script&lang=js"
export * from "./ListRoom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports